<template>
    <div class="input-group is-file" :class="{'is-dirty' : isDirty }">
        <div class="custom-file">
            <input ref="file" type="file" class="custom-file-input" :id="getFieldId" @change="upload($event)">
            <label class="custom-file-label overflow-hidden" :for="getFieldId" :aria-describedby="`inputGroupFile${getFieldId}`" v-text="__(getLabel)"></label>
            <label class="custom-file-name overflow-hidden" v-if="isDirty" v-text="__(fileName)"></label>
        </div>
    </div>
</template>
<script>

    let InputField = require('@/mixins/InputField');
    let UploadProgres = require('@/mixins/UploadProgres');

    export default {

        mixins: [InputField, UploadProgres],

        props: {
            model: {
                type: String,
                required: true,
            },
            modelId: {
                type: Number,
                required: true,
            }
        },

        data() {
            return {
                isDirty: false,
                fileName: 'Choose file',
            }
        },

        methods: {

            upload() {
                App.request().post(`/api/model-files`, this.data(), this.config()).then(response => {
                    this.fileName = response.data.file.name
                    this.isDirty = true
                    this.$emit('input', response.data.file)
                    this.$emit('uploaded')
                    App.bus.$emit('refresh-files')
                    document.activeElement.blur();
                }).catch(errors => {
                    Toast.error(errors.response.data.message)
                })
            },

            data() {
                let data = new FormData();
                data.append('model', this.model);
                data.append('model_id', this.modelId);
                data.append('file', this.$refs.file.files[0]);
                return data;
            },
        },

        computed: {
            getLabel() {
                if (!this.floating && this.isDirty) return '';
                return this.label;
            }
        },
    }
</script>
